document.addEventListener('DOMContentLoaded', () => {
  const productFormEl = document.querySelector('product-form');
  if (!productFormEl) return;

  const form = productFormEl.querySelector('form');
  const errorWrapper = productFormEl.querySelector('.product-form__error-message-wrapper');
  const errorMessage = productFormEl.querySelector('.product-form__error-message');

  function isValidEmail(email) {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  }

  form.addEventListener('submit', function(e) {
    const customerEmail = document.getElementById('CustomerEmail-{{ section.id }}');
    const recipientEmail = document.getElementById('RecipientEmail-{{ section.id }}');

    const recipientVisible = recipientEmail && recipientEmail.offsetParent !== null;

    if (recipientVisible) {
      if (!isValidEmail(customerEmail.value)) {
        e.preventDefault();
        e.stopImmediatePropagation(); // 🚨 THIS is the key
        errorMessage.textContent = "Please enter a valid email address.";
        errorWrapper.removeAttribute('hidden');
        customerEmail.focus();
        return;
      }

      if (!isValidEmail(recipientEmail.value)) {
        e.preventDefault();
        e.stopImmediatePropagation(); // 🚨 This stops Dawn
        errorMessage.textContent = "Please enter a valid recipient email address.";
        errorWrapper.removeAttribute('hidden');
        recipientEmail.focus();
        return;
      }
    }

    errorWrapper.setAttribute('hidden', true);
  }, true); // 👈 use capture phase
});